import React from "react";
import { useTranslation } from "react-i18next";

import { capitalizeFirstLetter } from "helpers/string";

import TableCell from "components/Tables/TableCell";

export default function LoadingType({ content }) {
    const { t } = useTranslation();
    const title = content.loading_types && content.loading_types.length > 0 ? capitalizeFirstLetter(content.loading_types.join(", ")) : '-';
    const description = content.gidrolift ? capitalizeFirstLetter(t("transportFields.body_section.tailLift").toLowerCase()) : "";

    return (
        <TableCell
            title={title}
            description={description}
        />
    );
}
